<template >
  <div class="leg-grid" id="legend" v-bind:style="{ 'min-height': getHeight + 'px;' }">

    <div class="card-body dash-card-body card-body-spacer">
      <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
        <h3 class="narrow_05">{{ getTitleText }} <span class="text8pt">({{$t('Webportal.DashboardBMW.AllValuesInPercent')}})</span></h3>
      </div>
      
      <div style="margin: 0px 4px;">
        <div class="legctrl-box">
          <div v-if="isLostLeads" class="legctrl-tab">
            <div class="legctrl-cell bc-green rounded2">{{ getTextLow() }}</div>
            <div class="legctrl-cell bc-yellow rounded2">{{ getTextMedium() }}</div>
            <div class="legctrl-cell bc-red rounded2">{{ getTextHigh() }}</div>
          </div>
          <div v-else class="legctrl-tab">
            <div class="legctrl-cell bc-red rounded2">{{ getTextRed() }}</div>
            <div class="legctrl-cell bc-yellow rounded2">{{ getTextYellow() }}</div>
            <div class="legctrl-cell bc-green rounded2">{{ getTextGreen() }}</div>
          </div>
        </div>

        <div v-if="showTextItems" class="legctrl-box">
          <div class="legctrl-tab">
            <div class="legctrl-cell10"><font-awesome-icon name="fa-thumbs-up" icon="star"></font-awesome-icon></div>
            <div class="legctrl-cell90" >{{ workingStandardsText }}</div>
          </div>
        </div>

        <div v-if="showTextItems" class="legctrl-box">
          <div class="legctrl-tab">
            <div class="legctrl-cell20">
              <div class="legctrl-borderbox" >
                <div>
                </div>
              </div>
            </div>
            <div class="legctrl-cell80">{{ successFactorsText }}</div>
          </div>
        </div>

        <div v-if="showNpsInfo" class="legctrl-box">
          <div class="legctrl-tab">
            <div class="legctrl-cell90">*{{$t('Webportal.Dashboard.NPS')}} ({{$t('Webportal.Dashboard.Score')}} = {{$t('Webportal.DashboardBMW.Promoters')}}-{{$t('Webportal.DashboardBMW.Detractors')}})</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LegendControl',

    props: {
      titleTextKey: { type: String, default: 'Webportal.DashboardBMW.PerformanceIndex' },
      titleText: { type: String, default: undefined },
      workingStandardsText: { type: String, default: '' },
      successFactorsText: { type: String, default: '' },
      isBMWMoto: { type: Boolean, default: false },
      isLostLeads: { type: Boolean, default: false },
      showTextItems: { type: Boolean, default: true },
      showNpsInfo: { type: Boolean, default: false },
      isBMW2020: { type: Boolean, default: false },
    },

    methods: {
      getTextRed() { return this.isBMWMoto ? '0-59' : (this.isBMW2020 ? '0-89' : '0-79'); },
      getTextYellow() {return this.isBMWMoto ? '60-79' : (this.isBMW2020 ? '90-99' : '80-89'); },
      getTextGreen() { return this.isBMWMoto ? '80-100' : (this.isBMW2020 ? '100' : '90-100'); },
      getTextLow() { return '0-4'; },
      getTextMedium() {return '5-9'; },
      getTextHigh() { return '10-100'; }
    },

    computed: {
      getTitleText: function() {
        if (_.isEmpty(this.titleText)) {
          return this.$t(this.titleTextKey);
        }
        return this.titleText;
      },
      getHeight: function() {
        return this.showNpsInfo ? 80 : 136;
      },
      getSuccessFactorsGroup: function() {
        return !this.successFactorsKpi ? '-' : this.successFactorsKpi.KpiName;
      },
      getWorkingStandardGroup: function() {
        return !this.workingStandardsKpi ? '-' : this.workingStandardsKpi.KpiName;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .card-body-spacer {
    padding: 0px;
  }


  #legend{
    position: relative;
    bottom:0px;
    background: transparent;
    /* height: 136px; */
  }

  .leg{
    position: relative;
    bottom:0px;
    background: transparent;
  }
  .leg-grid {
    grid-template-rows: 1fr 1fr;
  }
</style>
